// src/utils/captureChartAsImage.js

import { toPng } from 'html-to-image';

/**
 * Capture a chart as an image.
 * @param {HTMLElement} chartElement - The chart DOM element to capture.
 * @returns {Promise<string>} A promise that resolves with the image data URL.
 */
const captureChartAsImage = async (chartElement) => {
  try {
    const dataUrl = await toPng(chartElement);
    return dataUrl;
  } catch (error) {
    console.error('Error capturing chart as image:', error);
    throw error;
  }
};

export default captureChartAsImage;
